( function( $ ) {

    $(document).ready( function() {
        // Page removes all this from the dom the reinserts it. Need to bind events to document instead of element
        
        // careers Block
        $(window).bind('load resize', function() {
            $('.careers-body-wrapper').each(function() {
                let height = $(this).children('.careers-body-inner').outerHeight() + 'px';
                $(this).css('--body-height', height);

            });
        });


        $(document).on('click', '.careers-title', function() {
            console.log('Toggle careers');
            if($(this).parent().hasClass('open')) {
                $(this).parent().removeClass('open');
            } else {
                $('.careers-item').removeClass('open');
                $(this).parent().addClass('open');
            }
        });

    } );

} )( jQuery );
